"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenManagerProvider = exports.TokenManager = void 0;
const TOKEN_EXPIRATION_THRESHOLD = 0.75;
class TokenManager {
    constructor() {
        this.tokens = {};
    }
    setToken(clientId, token) {
        if (!clientId || !token) {
            return;
        }
        this.tokens[clientId] = token;
    }
    deleteToken(clientId) {
        if (!clientId) {
            return;
        }
        delete this.tokens[clientId];
    }
    getToken(clientId) {
        if (!clientId) {
            return null;
        }
        const token = this.tokens[clientId];
        if (!token) {
            return null;
        }
        if (!this.isTokenAlive(token)) {
            this.deleteToken(clientId);
            return null;
        }
        return token;
    }
    clear() {
        this.tokens = {};
    }
    isTokenAlive(token) {
        if (!token) {
            return false;
        }
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const exp = payload.exp * 1000;
            const iat = payload.iat * 1000;
            const now = Date.now();
            const lifetime = (exp - iat) * TOKEN_EXPIRATION_THRESHOLD;
            return iat + lifetime > now;
        }
        catch {
            return false;
        }
    }
}
exports.TokenManager = TokenManager;
const SHARED_TOKEN_MANAGER_SYMBOL = Symbol.for('TokenManager');
class TokenManagerProvider {
    static getInstance() {
        if (!window[SHARED_TOKEN_MANAGER_SYMBOL]) {
            window[SHARED_TOKEN_MANAGER_SYMBOL] = new TokenManager();
        }
        return window[SHARED_TOKEN_MANAGER_SYMBOL];
    }
}
exports.TokenManagerProvider = TokenManagerProvider;
